{
  "INBOX": {
    "LIST": {
      "404": "There are no active notifications in this group.",
      "TITLE": "My Inbox",
      "DISPLAY_DROPDOWN": "Display",
      "LOADING": "Fetching notifications",
      "NO_NOTIFICATIONS": "No notifications",
      "NOTE": "Notifications from all subscribed inboxes",
      "NO_MESSAGES_AVAILABLE": "Oops! Not able to fetch messages",
      "SNOOZED_UNTIL": "Uśpione do",
      "SNOOZED_UNTIL_TOMORROW": "Uśpij do jutra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Uśpione do następnego tygodnia"
    },
    "ACTION_HEADER": {
      "SNOOZE": "Snooze notification",
      "DELETE": "Delete notification",
      "BACK": "Powrót"
    },
    "TYPES": {
      "CONVERSATION_MENTION": "You have been mentioned in a conversation",
      "CONVERSATION_CREATION": "New conversation created",
      "CONVERSATION_ASSIGNMENT": "A conversation has been assigned to you",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "New message in an assigned conversation",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "New message in a conversation you are participating in",
      "SLA_MISSED_FIRST_RESPONSE": "SLA target first response missed for conversation",
      "SLA_MISSED_NEXT_RESPONSE": "SLA target next response missed for conversation",
      "SLA_MISSED_RESOLUTION": "SLA target resolution missed for conversation"
    },
    "TYPES_NEXT": {
      "CONVERSATION_MENTION": "Mentioned",
      "CONVERSATION_ASSIGNMENT": "Assigned to you",
      "CONVERSATION_CREATION": "New Conversation",
      "SLA_MISSED_FIRST_RESPONSE": "SLA breach",
      "SLA_MISSED_NEXT_RESPONSE": "SLA breach",
      "SLA_MISSED_RESOLUTION": "SLA breach",
      "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Nowa wiadomość",
      "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Nowa wiadomość",
      "SNOOZED_UNTIL": "Snoozed for {time}",
      "SNOOZED_ENDS": "Snooze ended",
      "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "Nowa wiadomość"
    },
    "NO_CONTENT": "Brak treści",
    "PHONE_CALL_TYPES": {
      "OUTBOUND_CONNECTED": "Połączenie wychodzące - Nawiązane",
      "OUTBOUND_FAILED": "Połączenie wychodzące - Nieudane",
      "INBOUND_MISSED": "Połączenie przychodzące - Nieodebrane",
      "INBOUND_UNANSWERED_MISSED": "Połączenie przychodzące - Nieodebrane bez oddzwonienia",
      "INBOUND_AGENT": "Połączenie przychodzące - Odebrane przez agenta",
      "INBOUND_IVR": "Połączenie przychodzące - Odebrane przez IVR",
      "DEFAULT": "Połączenie telefoniczne"
    },
    "MENU_ITEM": {
      "MARK_AS_READ": "Mark as read",
      "MARK_AS_UNREAD": "Oznacz jako nieprzeczytane",
      "SNOOZE": "Uśpij",
      "DELETE": "Usuń",
      "MARK_ALL_READ": "Oznacz wszystko jako przeczytane",
      "DELETE_ALL": "Delete all",
      "DELETE_ALL_READ": "Delete all read"
    },
    "DISPLAY_MENU": {
      "SORT": "Sort",
      "DISPLAY": "Display :",
      "SORT_OPTIONS": {
        "NEWEST": "Newest",
        "OLDEST": "Oldest",
        "PRIORITY": "Priorytet"
      },
      "DISPLAY_OPTIONS": {
        "SNOOZED": "Uśpij",
        "READ": "Przeczytane",
        "LABELS": "Etykiety",
        "CONVERSATION_ID": "Conversation ID"
      }
    },
    "ALERTS": {
      "MARK_AS_READ": "Notification marked as read",
      "MARK_AS_UNREAD": "Notification marked as unread",
      "SNOOZE": "Notification snoozed",
      "DELETE": "Notification deleted",
      "MARK_ALL_READ": "All notifications marked as read",
      "DELETE_ALL": "All notifications deleted",
      "DELETE_ALL_READ": "All read notifications deleted"
    }
  }
}
